import { DOWN_ARROW_KEY, ENTER_KEY, ESCAPE_KEY, TAB_KEY, UP_ARROW_KEY } from '../../../const/keyNames';
export const handleOnMouseDown = (event, wrapperRef, setIsOpen) => {
    // this instanceof check is required to refine EventTarget to Node types
    if (wrapperRef.current && event.target instanceof Node) {
        setTimeout(() => {
            setIsOpen(false);
        }, 300);
    }
};
// eslint-disable-next-line import/prefer-default-export
export const handleKeyboardDown = (event, isOpen, selectedIndex, childrenArr, setSelectedIndex, activeChildRef, toggleMenu) => {
    if (!isOpen)
        return;
    switch (event.key) {
        case ESCAPE_KEY:
            toggleMenu();
            break;
        case DOWN_ARROW_KEY:
        case TAB_KEY:
            if (event.shiftKey && selectedIndex >= 0) {
                setSelectedIndex(selectedIndex - 1);
            }
            else if (!event.shiftKey && selectedIndex < childrenArr.length - 1) {
                setSelectedIndex(selectedIndex + 1);
            }
            break;
        case UP_ARROW_KEY:
            if (selectedIndex > 0) {
                setSelectedIndex(selectedIndex - 1);
            }
            break;
        case ENTER_KEY:
            if (activeChildRef && activeChildRef.current) {
                activeChildRef.current.click();
                toggleMenu();
            }
            break;
        default:
    }
};
